// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card[data-v-b05bb612]{margin-left:auto;margin-right:auto;width:90%}@media (min-width:768px){.v-card[data-v-b05bb612]{width:556px}}@media (min-width:1280px){.v-card[data-v-b05bb612]{padding:15px;width:556px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
